import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 24px;
    padding: 24px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 20px;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0;
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    flex-direction: column;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 8px;
    line-height: 1.5;

    & > p {
      margin: 0;
    }
  `}
`;

export const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 500px;
  width: 100%;
`;

export const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 500px;
  width: 100%;
`;
